// Generated by tools/letters/build.py from content/*/letters.json — do not edit.
//
// The Letters reference ([Review](../../../docs/REVIEW.md#letters)).
/** English's alphabet. */
export const LETTERS = [
    {
        "letter": "a",
        "name": "ay",
        "nameAudioRef": "audio/en/letters/name-a.mp3",
        "sounds": [
            {
                "sound": "a",
                "word": "apple",
                "emoji": "🍎",
                "audioRef": "audio/en/letters/word-apple.mp3",
                "phonemes": [
                    "æ"
                ]
            },
            {
                "sound": "ay",
                "word": "cake",
                "emoji": "🎂",
                "audioRef": "audio/en/letters/word-cake.mp3",
                "phonemes": [
                    "eɪ"
                ]
            }
        ]
    },
    {
        "letter": "b",
        "name": "bee",
        "nameAudioRef": "audio/en/letters/name-b.mp3",
        "sounds": [
            {
                "sound": "b",
                "word": "ball",
                "emoji": "⚽",
                "audioRef": "audio/en/letters/word-ball.mp3",
                "phonemes": [
                    "b"
                ]
            }
        ]
    },
    {
        "letter": "c",
        "name": "see",
        "nameAudioRef": "audio/en/letters/name-c.mp3",
        "sounds": [
            {
                "sound": "k",
                "word": "cat",
                "emoji": "🐱",
                "audioRef": "audio/en/letters/word-cat.mp3",
                "phonemes": [
                    "k"
                ]
            },
            {
                "sound": "s",
                "word": "city",
                "emoji": "🏙️",
                "audioRef": "audio/en/letters/word-city.mp3",
                "phonemes": [
                    "s"
                ]
            }
        ]
    },
    {
        "letter": "d",
        "name": "dee",
        "nameAudioRef": "audio/en/letters/name-d.mp3",
        "sounds": [
            {
                "sound": "d",
                "word": "dog",
                "emoji": "🐶",
                "audioRef": "audio/en/letters/word-dog.mp3",
                "phonemes": [
                    "d"
                ]
            }
        ]
    },
    {
        "letter": "e",
        "name": "ee",
        "nameAudioRef": "audio/en/letters/name-e.mp3",
        "sounds": [
            {
                "sound": "e",
                "word": "egg",
                "emoji": "🥚",
                "audioRef": "audio/en/letters/word-egg.mp3",
                "phonemes": [
                    "e"
                ]
            },
            {
                "sound": "ee",
                "word": "tree",
                "emoji": "🌳",
                "audioRef": "audio/en/letters/word-tree.mp3",
                "phonemes": [
                    "iː"
                ]
            }
        ]
    },
    {
        "letter": "f",
        "name": "eff",
        "nameAudioRef": "audio/en/letters/name-f.mp3",
        "sounds": [
            {
                "sound": "f",
                "word": "fish",
                "emoji": "🐟",
                "audioRef": "audio/en/letters/word-fish.mp3",
                "phonemes": [
                    "f"
                ]
            }
        ]
    },
    {
        "letter": "g",
        "name": "gee",
        "nameAudioRef": "audio/en/letters/name-g.mp3",
        "sounds": [
            {
                "sound": "g",
                "word": "goat",
                "emoji": "🐐",
                "audioRef": "audio/en/letters/word-goat.mp3",
                "phonemes": [
                    "ɡ"
                ]
            },
            {
                "sound": "j",
                "word": "giraffe",
                "emoji": "🦒",
                "audioRef": "audio/en/letters/word-giraffe.mp3",
                "phonemes": [
                    "dʒ"
                ]
            }
        ]
    },
    {
        "letter": "h",
        "name": "aitch",
        "nameAudioRef": "audio/en/letters/name-h.mp3",
        "sounds": [
            {
                "sound": "h",
                "word": "hat",
                "emoji": "🎩",
                "audioRef": "audio/en/letters/word-hat.mp3",
                "phonemes": [
                    "h"
                ]
            }
        ]
    },
    {
        "letter": "i",
        "name": "eye",
        "nameAudioRef": "audio/en/letters/name-i.mp3",
        "sounds": [
            {
                "sound": "i",
                "word": "insect",
                "emoji": "🐛",
                "audioRef": "audio/en/letters/word-insect.mp3",
                "phonemes": [
                    "ɪ"
                ]
            },
            {
                "sound": "eye",
                "word": "ice",
                "emoji": "🧊",
                "audioRef": "audio/en/letters/word-ice.mp3",
                "phonemes": [
                    "aɪ"
                ]
            }
        ]
    },
    {
        "letter": "j",
        "name": "jay",
        "nameAudioRef": "audio/en/letters/name-j.mp3",
        "sounds": [
            {
                "sound": "j",
                "word": "juice",
                "emoji": "🧃",
                "audioRef": "audio/en/letters/word-juice.mp3",
                "phonemes": [
                    "dʒ"
                ]
            }
        ]
    },
    {
        "letter": "k",
        "name": "kay",
        "nameAudioRef": "audio/en/letters/name-k.mp3",
        "sounds": [
            {
                "sound": "k",
                "word": "kite",
                "emoji": "🪁",
                "audioRef": "audio/en/letters/word-kite.mp3",
                "phonemes": [
                    "k"
                ]
            }
        ]
    },
    {
        "letter": "l",
        "name": "ell",
        "nameAudioRef": "audio/en/letters/name-l.mp3",
        "sounds": [
            {
                "sound": "l",
                "word": "lion",
                "emoji": "🦁",
                "audioRef": "audio/en/letters/word-lion.mp3",
                "phonemes": [
                    "l"
                ]
            }
        ]
    },
    {
        "letter": "m",
        "name": "em",
        "nameAudioRef": "audio/en/letters/name-m.mp3",
        "sounds": [
            {
                "sound": "m",
                "word": "moon",
                "emoji": "🌙",
                "audioRef": "audio/en/letters/word-moon.mp3",
                "phonemes": [
                    "m"
                ]
            }
        ]
    },
    {
        "letter": "n",
        "name": "en",
        "nameAudioRef": "audio/en/letters/name-n.mp3",
        "sounds": [
            {
                "sound": "n",
                "word": "nose",
                "emoji": "👃",
                "audioRef": "audio/en/letters/word-nose.mp3",
                "phonemes": [
                    "n"
                ]
            }
        ]
    },
    {
        "letter": "o",
        "name": "oh",
        "nameAudioRef": "audio/en/letters/name-o.mp3",
        "sounds": [
            {
                "sound": "o",
                "word": "orange",
                "emoji": "🍊",
                "audioRef": "audio/en/letters/word-orange.mp3",
                "phonemes": [
                    "ɒ"
                ]
            },
            {
                "sound": "oh",
                "word": "go",
                "emoji": "🚦",
                "audioRef": "audio/en/letters/word-go.mp3",
                "phonemes": [
                    "əʊ"
                ]
            }
        ]
    },
    {
        "letter": "p",
        "name": "pee",
        "nameAudioRef": "audio/en/letters/name-p.mp3",
        "sounds": [
            {
                "sound": "p",
                "word": "pig",
                "emoji": "🐷",
                "audioRef": "audio/en/letters/word-pig.mp3",
                "phonemes": [
                    "p"
                ]
            }
        ]
    },
    {
        "letter": "q",
        "name": "cue",
        "nameAudioRef": "audio/en/letters/name-q.mp3",
        "sounds": [
            {
                "sound": "kw",
                "word": "queen",
                "emoji": "👑",
                "audioRef": "audio/en/letters/word-queen.mp3",
                "phonemes": [
                    "k",
                    "w"
                ]
            }
        ]
    },
    {
        "letter": "r",
        "name": "ar",
        "nameAudioRef": "audio/en/letters/name-r.mp3",
        "sounds": [
            {
                "sound": "r",
                "word": "rabbit",
                "emoji": "🐰",
                "audioRef": "audio/en/letters/word-rabbit.mp3",
                "phonemes": [
                    "r"
                ]
            }
        ]
    },
    {
        "letter": "s",
        "name": "ess",
        "nameAudioRef": "audio/en/letters/name-s.mp3",
        "sounds": [
            {
                "sound": "s",
                "word": "sun",
                "emoji": "☀️",
                "audioRef": "audio/en/letters/word-sun.mp3",
                "phonemes": [
                    "s"
                ]
            }
        ]
    },
    {
        "letter": "t",
        "name": "tee",
        "nameAudioRef": "audio/en/letters/name-t.mp3",
        "sounds": [
            {
                "sound": "t",
                "word": "tiger",
                "emoji": "🐯",
                "audioRef": "audio/en/letters/word-tiger.mp3",
                "phonemes": [
                    "t"
                ]
            }
        ]
    },
    {
        "letter": "u",
        "name": "you",
        "nameAudioRef": "audio/en/letters/name-u.mp3",
        "sounds": [
            {
                "sound": "u",
                "word": "umbrella",
                "emoji": "☂️",
                "audioRef": "audio/en/letters/word-umbrella.mp3",
                "phonemes": [
                    "ʌ"
                ]
            },
            {
                "sound": "you",
                "word": "unicorn",
                "emoji": "🦄",
                "audioRef": "audio/en/letters/word-unicorn.mp3",
                "phonemes": [
                    "j",
                    "uː"
                ]
            }
        ]
    },
    {
        "letter": "v",
        "name": "vee",
        "nameAudioRef": "audio/en/letters/name-v.mp3",
        "sounds": [
            {
                "sound": "v",
                "word": "van",
                "emoji": "🚐",
                "audioRef": "audio/en/letters/word-van.mp3",
                "phonemes": [
                    "v"
                ]
            }
        ]
    },
    {
        "letter": "w",
        "name": "double-you",
        "nameAudioRef": "audio/en/letters/name-w.mp3",
        "sounds": [
            {
                "sound": "w",
                "word": "water",
                "emoji": "💧",
                "audioRef": "audio/en/letters/word-water.mp3",
                "phonemes": [
                    "w"
                ]
            }
        ]
    },
    {
        "letter": "x",
        "name": "ex",
        "nameAudioRef": "audio/en/letters/name-x.mp3",
        "sounds": [
            {
                "sound": "ks",
                "word": "box",
                "emoji": "📦",
                "audioRef": "audio/en/letters/word-box.mp3",
                "phonemes": [
                    "k",
                    "s"
                ]
            }
        ]
    },
    {
        "letter": "y",
        "name": "why",
        "nameAudioRef": "audio/en/letters/name-y.mp3",
        "sounds": [
            {
                "sound": "y",
                "word": "yellow",
                "emoji": "💛",
                "audioRef": "audio/en/letters/word-yellow.mp3",
                "phonemes": [
                    "j"
                ]
            }
        ]
    },
    {
        "letter": "z",
        "name": "zed",
        "nameAudioRef": "audio/en/letters/name-z.mp3",
        "sounds": [
            {
                "sound": "z",
                "word": "zebra",
                "emoji": "🦓",
                "audioRef": "audio/en/letters/word-zebra.mp3",
                "phonemes": [
                    "z"
                ]
            }
        ]
    }
];
/** Every course's alphabet, by the language it teaches (D-190). */
export const LETTERS_BY_LANGUAGE = {
    en: LETTERS,
    sv: [
        {
            "letter": "a",
            "name": "a",
            "nameAudioRef": "audio/sv/letters/name-a.mp3",
            "sounds": [
                {
                    "sound": "a",
                    "word": "katt",
                    "emoji": "🐱",
                    "audioRef": "audio/sv/letters/word-katt.mp3",
                    "phonemes": [
                        "a"
                    ]
                },
                {
                    "sound": "long a",
                    "word": "apa",
                    "emoji": "🐒",
                    "audioRef": "audio/sv/letters/word-apa.mp3",
                    "phonemes": [
                        "ɑː"
                    ]
                }
            ]
        },
        {
            "letter": "b",
            "name": "be",
            "nameAudioRef": "audio/sv/letters/name-b.mp3",
            "sounds": [
                {
                    "sound": "b",
                    "word": "boll",
                    "emoji": "⚽",
                    "audioRef": "audio/sv/letters/word-boll.mp3",
                    "phonemes": [
                        "b"
                    ]
                }
            ]
        },
        {
            "letter": "c",
            "name": "se",
            "nameAudioRef": "audio/sv/letters/name-c.mp3",
            "sounds": [
                {
                    "sound": "s",
                    "word": "cykel",
                    "emoji": "🚲",
                    "audioRef": "audio/sv/letters/word-cykel.mp3",
                    "phonemes": [
                        "s"
                    ]
                }
            ]
        },
        {
            "letter": "d",
            "name": "de",
            "nameAudioRef": "audio/sv/letters/name-d.mp3",
            "sounds": [
                {
                    "sound": "d",
                    "word": "dörr",
                    "emoji": "🚪",
                    "audioRef": "audio/sv/letters/word-doerr.mp3",
                    "phonemes": [
                        "d"
                    ]
                }
            ]
        },
        {
            "letter": "e",
            "name": "e",
            "nameAudioRef": "audio/sv/letters/name-e.mp3",
            "sounds": [
                {
                    "sound": "e",
                    "word": "elefant",
                    "emoji": "🐘",
                    "audioRef": "audio/sv/letters/word-elefant.mp3",
                    "phonemes": [
                        "ɛ"
                    ]
                }
            ]
        },
        {
            "letter": "f",
            "name": "eff",
            "nameAudioRef": "audio/sv/letters/name-f.mp3",
            "sounds": [
                {
                    "sound": "f",
                    "word": "fisk",
                    "emoji": "🐟",
                    "audioRef": "audio/sv/letters/word-fisk.mp3",
                    "phonemes": [
                        "f"
                    ]
                }
            ]
        },
        {
            "letter": "g",
            "name": "ge",
            "nameAudioRef": "audio/sv/letters/name-g.mp3",
            "sounds": [
                {
                    "sound": "g",
                    "word": "glass",
                    "emoji": "🍦",
                    "audioRef": "audio/sv/letters/word-glass.mp3",
                    "phonemes": [
                        "ɡ"
                    ]
                },
                {
                    "sound": "soft g",
                    "word": "get",
                    "emoji": "🐐",
                    "audioRef": "audio/sv/letters/word-get.mp3",
                    "phonemes": [
                        "j"
                    ]
                }
            ]
        },
        {
            "letter": "h",
            "name": "hå",
            "nameAudioRef": "audio/sv/letters/name-h.mp3",
            "sounds": [
                {
                    "sound": "h",
                    "word": "hund",
                    "emoji": "🐶",
                    "audioRef": "audio/sv/letters/word-hund.mp3",
                    "phonemes": [
                        "h"
                    ]
                }
            ]
        },
        {
            "letter": "i",
            "name": "i",
            "nameAudioRef": "audio/sv/letters/name-i.mp3",
            "sounds": [
                {
                    "sound": "i",
                    "word": "is",
                    "emoji": "🧊",
                    "audioRef": "audio/sv/letters/word-is.mp3",
                    "phonemes": [
                        "iː"
                    ]
                }
            ]
        },
        {
            "letter": "j",
            "name": "ji",
            "nameAudioRef": "audio/sv/letters/name-j.mp3",
            "sounds": [
                {
                    "sound": "j",
                    "word": "jordgubbe",
                    "emoji": "🍓",
                    "audioRef": "audio/sv/letters/word-jordgubbe.mp3",
                    "phonemes": [
                        "j"
                    ]
                }
            ]
        },
        {
            "letter": "k",
            "name": "kå",
            "nameAudioRef": "audio/sv/letters/name-k.mp3",
            "sounds": [
                {
                    "sound": "k",
                    "word": "katt",
                    "emoji": "🐱",
                    "audioRef": "audio/sv/letters/word-katt.mp3",
                    "phonemes": [
                        "k"
                    ]
                },
                {
                    "sound": "soft k",
                    "word": "kyckling",
                    "emoji": "🐥",
                    "audioRef": "audio/sv/letters/word-kyckling.mp3",
                    "phonemes": [
                        "ɕ"
                    ]
                }
            ]
        },
        {
            "letter": "l",
            "name": "ell",
            "nameAudioRef": "audio/sv/letters/name-l.mp3",
            "sounds": [
                {
                    "sound": "l",
                    "word": "lejon",
                    "emoji": "🦁",
                    "audioRef": "audio/sv/letters/word-lejon.mp3",
                    "phonemes": [
                        "l"
                    ]
                }
            ]
        },
        {
            "letter": "m",
            "name": "emm",
            "nameAudioRef": "audio/sv/letters/name-m.mp3",
            "sounds": [
                {
                    "sound": "m",
                    "word": "mus",
                    "emoji": "🐭",
                    "audioRef": "audio/sv/letters/word-mus.mp3",
                    "phonemes": [
                        "m"
                    ]
                }
            ]
        },
        {
            "letter": "n",
            "name": "enn",
            "nameAudioRef": "audio/sv/letters/name-n.mp3",
            "sounds": [
                {
                    "sound": "n",
                    "word": "näsa",
                    "emoji": "👃",
                    "audioRef": "audio/sv/letters/word-naesa.mp3",
                    "phonemes": [
                        "n"
                    ]
                }
            ]
        },
        {
            "letter": "o",
            "name": "o",
            "nameAudioRef": "audio/sv/letters/name-o.mp3",
            "sounds": [
                {
                    "sound": "o",
                    "word": "orm",
                    "emoji": "🐍",
                    "audioRef": "audio/sv/letters/word-orm.mp3",
                    "phonemes": [
                        "ʊ"
                    ]
                },
                {
                    "sound": "long o",
                    "word": "sol",
                    "emoji": "☀️",
                    "audioRef": "audio/sv/letters/word-sol.mp3",
                    "phonemes": [
                        "uː"
                    ]
                }
            ]
        },
        {
            "letter": "p",
            "name": "pe",
            "nameAudioRef": "audio/sv/letters/name-p.mp3",
            "sounds": [
                {
                    "sound": "p",
                    "word": "pizza",
                    "emoji": "🍕",
                    "audioRef": "audio/sv/letters/word-pizza.mp3",
                    "phonemes": [
                        "p"
                    ]
                }
            ]
        },
        {
            "letter": "q",
            "name": "ku",
            "nameAudioRef": "audio/sv/letters/name-q.mp3",
            "sounds": [
                {
                    "sound": "k",
                    "word": "quiz",
                    "emoji": "❓",
                    "audioRef": "audio/sv/letters/word-quiz.mp3",
                    "phonemes": [
                        "k"
                    ]
                }
            ]
        },
        {
            "letter": "r",
            "name": "ärr",
            "nameAudioRef": "audio/sv/letters/name-r.mp3",
            "sounds": [
                {
                    "sound": "r",
                    "word": "räv",
                    "emoji": "🦊",
                    "audioRef": "audio/sv/letters/word-raev.mp3",
                    "phonemes": [
                        "r"
                    ]
                }
            ]
        },
        {
            "letter": "s",
            "name": "ess",
            "nameAudioRef": "audio/sv/letters/name-s.mp3",
            "sounds": [
                {
                    "sound": "s",
                    "word": "sol",
                    "emoji": "☀️",
                    "audioRef": "audio/sv/letters/word-sol.mp3",
                    "phonemes": [
                        "s"
                    ]
                },
                {
                    "sound": "sj",
                    "word": "sju",
                    "emoji": "7️⃣",
                    "audioRef": "audio/sv/letters/word-sju.mp3",
                    "phonemes": [
                        "ɧ"
                    ]
                }
            ]
        },
        {
            "letter": "t",
            "name": "te",
            "nameAudioRef": "audio/sv/letters/name-t.mp3",
            "sounds": [
                {
                    "sound": "t",
                    "word": "tåg",
                    "emoji": "🚆",
                    "audioRef": "audio/sv/letters/word-taag.mp3",
                    "phonemes": [
                        "t"
                    ]
                },
                {
                    "sound": "tj",
                    "word": "tjej",
                    "emoji": "👧",
                    "audioRef": "audio/sv/letters/word-tjej.mp3",
                    "phonemes": [
                        "ɕ"
                    ]
                }
            ]
        },
        {
            "letter": "u",
            "name": "u",
            "nameAudioRef": "audio/sv/letters/name-u.mp3",
            "sounds": [
                {
                    "sound": "u",
                    "word": "uggla",
                    "emoji": "🦉",
                    "audioRef": "audio/sv/letters/word-uggla.mp3",
                    "phonemes": [
                        "ɵ"
                    ]
                },
                {
                    "sound": "long u",
                    "word": "ufo",
                    "emoji": "🛸",
                    "audioRef": "audio/sv/letters/word-ufo.mp3",
                    "phonemes": [
                        "ʉː"
                    ]
                }
            ]
        },
        {
            "letter": "v",
            "name": "ve",
            "nameAudioRef": "audio/sv/letters/name-v.mp3",
            "sounds": [
                {
                    "sound": "v",
                    "word": "val",
                    "emoji": "🐋",
                    "audioRef": "audio/sv/letters/word-val.mp3",
                    "phonemes": [
                        "v"
                    ]
                }
            ]
        },
        {
            "letter": "w",
            "name": "dubbel-ve",
            "nameAudioRef": "audio/sv/letters/name-w.mp3",
            "sounds": [
                {
                    "sound": "v",
                    "word": "webb",
                    "emoji": "🌐",
                    "audioRef": "audio/sv/letters/word-webb.mp3",
                    "phonemes": [
                        "v"
                    ]
                }
            ]
        },
        {
            "letter": "x",
            "name": "eks",
            "nameAudioRef": "audio/sv/letters/name-x.mp3",
            "sounds": [
                {
                    "sound": "ks",
                    "word": "xylofon",
                    "emoji": "🎶",
                    "audioRef": "audio/sv/letters/word-xylofon.mp3",
                    "phonemes": [
                        "s"
                    ]
                }
            ]
        },
        {
            "letter": "y",
            "name": "y",
            "nameAudioRef": "audio/sv/letters/name-y.mp3",
            "sounds": [
                {
                    "sound": "y",
                    "word": "yxa",
                    "emoji": "🪓",
                    "audioRef": "audio/sv/letters/word-yxa.mp3",
                    "phonemes": [
                        "yː"
                    ]
                }
            ]
        },
        {
            "letter": "z",
            "name": "säta",
            "nameAudioRef": "audio/sv/letters/name-z.mp3",
            "sounds": [
                {
                    "sound": "s",
                    "word": "zebra",
                    "emoji": "🦓",
                    "audioRef": "audio/sv/letters/word-zebra.mp3",
                    "phonemes": [
                        "s"
                    ]
                }
            ]
        },
        {
            "letter": "å",
            "name": "å",
            "nameAudioRef": "audio/sv/letters/name-aa.mp3",
            "sounds": [
                {
                    "sound": "å",
                    "word": "åsna",
                    "emoji": "🫏",
                    "audioRef": "audio/sv/letters/word-aasna.mp3",
                    "phonemes": [
                        "oː"
                    ]
                }
            ]
        },
        {
            "letter": "ä",
            "name": "ä",
            "nameAudioRef": "audio/sv/letters/name-ae.mp3",
            "sounds": [
                {
                    "sound": "ä",
                    "word": "äpple",
                    "emoji": "🍎",
                    "audioRef": "audio/sv/letters/word-aepple.mp3",
                    "phonemes": [
                        "ɛ"
                    ]
                }
            ]
        },
        {
            "letter": "ö",
            "name": "ö",
            "nameAudioRef": "audio/sv/letters/name-oe.mp3",
            "sounds": [
                {
                    "sound": "ö",
                    "word": "öga",
                    "emoji": "👁️",
                    "audioRef": "audio/sv/letters/word-oega.mp3",
                    "phonemes": [
                        "øː"
                    ]
                }
            ]
        }
    ],
};
/** The alphabet of the language a child is learning; English for one without. */
export const lettersFor = (l2) => LETTERS_BY_LANGUAGE[l2] ?? LETTERS;
//# sourceMappingURL=letters.generated.js.map